import axios from 'axios'
export default {
    namespaced: true,
    state: {
		name: 'VehicleInsuranceType',
		endpoint: '/vehicle/insurance/type',
        items: [],
    },
    actions: {
		load (context, param) {
			//console.log('load','param', param)

			return axios.get(context.getters.endpoint).then(response => {
				//console.log('load','response.data', response.data)
				context.commit('items', response.data)
			}, error => {
				console.log(error)
			})
		},
    }
}